module.exports = __webpack_public_path__ + "static/media/pnid-explorer.73bc523c.png";